const calendlyBookEventUrlSelector = "[data-calendly-book-event-url]";

function init() {
  const calendlyContainers = document.querySelectorAll(calendlyBookEventUrlSelector);
  if (calendlyContainers.length == 0) return;

  const calendlyJs = document.createElement("script");
  calendlyJs.type = "text/javascript";
  calendlyJs.src = "https://assets.calendly.com/assets/external/widget.js";

  document.body.appendChild(calendlyJs);
}

function show(form) {
  const calendlyContainer = form.querySelector("[data-calendly-book-event-url]");
  if (!calendlyContainer) return;

  const bookEventURL = calendlyContainer.dataset.calendlyBookEventUrl;

  const { fname, lname, ...rest } = Array.from(form.querySelectorAll("[data-form-field-value]")).reduce((prefill, input) => {
    if (["fname", "lname", "email"].includes(input.name)) {
      return { ...prefill, [input.name]: input.value };
    } else {
      return {
        ...prefill,
        customAnswers: {
          ...prefill.customAnswers,
          [input.name]: input.value
        }
      };
    }
  }, {});

  const prefill = {
    name: [fname, lname].join(" "),
    ...rest
  };

  Calendly.initInlineWidget({
    url: bookEventURL,
    parentElement: calendlyContainer,
    prefill: prefill
  });

  hideSpinner(form);
}

function hideSpinner(form) {
  const iframe = form.querySelector("iframe");
  if (!iframe) return setInterval(hideSpinner(form), 500);

  const spinner = form.querySelector("[data-calendly-spinner]");
  const calendlyContainer = form.querySelector("[data-calendly-book-event-url]");

  setInterval(() => {
    spinner.classList.add("invisible");
    calendlyContainer.classList.remove("invisible");
  }, 1000);
}

export { init, show };